import axios from "axios";
import { VariableExport } from "../main.js";

var variable = VariableExport();

export async function IDToHuman(id, deviceType) {
  // VariableExport();
  // let test = VariableExport();

  let LookUpUrl =
    "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    variable.environment +
    "/lookup";
  let LookUpHeadersFeed = variable.apikeyPost;
  let LookUpRequest = {
    RequestType: "DeviceName",
    Company: deviceType,

    DataDict: [
      {
        IDList: id,
      },
    ],
  };

  let dataresponse = await axios
    .post(LookUpUrl, LookUpRequest, LookUpHeadersFeed)
    .then((response) => {
      return response;
    });

  return dataresponse.data.Values;
}
